import { render, staticRenderFns } from "./frmbefizetes_eredmeny.vue?vue&type=template&id=f495df32&"
import script from "./frmbefizetes_eredmeny.vue?vue&type=script&lang=js&"
export * from "./frmbefizetes_eredmeny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports